import {
  SELECT_RECOMMENDATION,
  SELECT_IMMUNIZATION,
  SELECT_PATHOLOGY,
  REMOVE_SELECTED_RECOMMENDATION,
  REMOVE_SELECTED_IMMUNIZATION,
  SELECT_EMPTY_INSERTION,
  REMOVE_EMPTY_INSERTION,
  REMOVE_SELECTED_PATHOLOGY,
  REMOVE_CURRENT_SELECTIONS,
  SELECT_PREVIOUS_INSERTION,
  REMOVE_PREVIOUS_INSERTION
} from './types'

export function selectRecommendation (recommendation) {
  return {
    type: SELECT_RECOMMENDATION,
    payload: recommendation
  }
}

export function selectImmunization (immunization) {
  return {
    type: SELECT_IMMUNIZATION,
    payload: immunization
  }
}

export function selectPathology (pathology) {
  return {
    type: SELECT_PATHOLOGY,
    payload: pathology
  }
}

export function removeSelectedRecommendation () {
  return {
    type: REMOVE_SELECTED_RECOMMENDATION
  }
}

export function removeSelectedImmunization () {
  return {
    type: REMOVE_SELECTED_IMMUNIZATION
  }
}

export function removeSelectedPathology () {
  return {
    type: REMOVE_SELECTED_PATHOLOGY
  }
}

export function selectEmptyInsertion (type) {
  return {
    type: SELECT_EMPTY_INSERTION,
    payload: type
  }
}

export function removeEmptyInsertion () {
  return {
    type: REMOVE_EMPTY_INSERTION
  }
}

export function selectPreviousInsertion (type) {
  return {
    type: SELECT_PREVIOUS_INSERTION,
    payload: type
  }
}

export function removePreviousInsertion (type) {
  return {
    type: REMOVE_PREVIOUS_INSERTION,
    payload: type
  }
}

export function removeCurrentSelections () {
  return {
    type: REMOVE_CURRENT_SELECTIONS
  }
}
